"use client";

import { Icon } from "@/components/ui/icon";

export function PanelBackButton({ onBack }: { onBack: () => void }) {
  return (
    <button
      type="button"
      onClick={onBack}
      className="flex h-8 shrink-0 cursor-pointer items-center gap-1.5 rounded-md px-1.5 text-muted-foreground"
    >
      <Icon
        name="IconChevronLeft"
        className="text-muted-foreground size-3.5"
      />
      <span className="text-sm font-medium leading-5">Back</span>
    </button>
  );
}
